import type { ClientConfig } from '@crm/validation';

/**
 * This client's branding, defaults and features: the whole rebrand surface (ADR-0025). Validated
 * against the shared schema at build time; a wrong value fails the build with the field named.
 * Written by `pnpm create-client`; edit by hand afterwards.
 */
export const clientConfig: ClientConfig = {
  name: 'MCL-AGOS',
  slug: 'mcl-agos',
  accent: '#4F46E5',
  logo: null,
  defaultTheme: 'system',
  defaults: { country: 'US', currency: 'USD', timezone: 'America/New_York' },
  features: {
    gmail: true,
    webhooks: true,
    ai: true,
    imports: true,
    bugReports: true,
    research: true,
    outreach: true,
    workflows: true,
    enrichment: true,
    mcp: true,
  },
  labels: { company: { singular: 'City', plural: 'Cities' } },
  gmailAppVerified: false,
  supportEmail: null,
  allowedEmailDomains: [],
  legal: {
    privacyUrl: null,
    termsUrl: null,
  },
};
